import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getFormSyncErrors, getFormValues} from "redux-form";
import * as galleryImageActions from '../../actions/gallery/galleryImageActions';
import * as submitButtonActions from '../../actions/submit/submitButtonActions';
import * as modalActions from '../../actions/common/modalActions';
import {toastr} from 'react-redux-toastr';
import {FormattedMessage, injectIntl} from 'react-intl';
import {messages} from  '../common/Translations';
import WithResolvedPromises from "../common/WithResolvedPromises";
import Placeholder from "../Placeholder";
import PlaceholderError from "../common/PlaceholderError";
import ResetFormModal from "../ResetFormModal";
import GalleryImageForm from "./GalleryImageForm";
import PrivateAPIResource from "../../services/PrivateAPIResource";
import {plainJSTranslator} from "../../common/PlainJSTranslator";
import 'react-image-crop/dist/ReactCrop.css';
import {Link} from "react-router-dom";

class GalleryImageFormContainer extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.defaultImageProps = {
            mimeType: "image/x-png, image/png, image/jpg, image/jpeg, image/gif",
            maxWeight: 10, // Mb
            maxWidth: 1920, // px
            maxHeight: 1080  // px
        };

        this.submit = this.submit.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.isUpdate = this.isUpdate.bind(this);
        this.handleSelectedFile = this.handleSelectedFile.bind(this);

        this.state = {
            selectedFile: null,
            isUpdating: false,
            fileErrorMessages: [],
        };

        this.actions = this.getRequiredActions();
    }

    getRequiredActions() {
        let actions = [];

        if (this.isUpdate()) {
            actions.push(this.props.actions.loadGalleryImage(
                this.props.match.params.galleryId,
                this.props.match.params.id
            ));
        } else {
            actions.push(this.props.actions.resetGalleryImage());
        }
        return actions;
    }

    isUpdate() {
        return this.props.match.params.hasOwnProperty('id');
    }

    confirmReset() {
        this.props.actions.hideResetFormModal();
        this.redirect();
    }

    handleReset() {
        this.props.actions.showResetFormModal();
    }

    redirect() {
        this.context.router.history.push('/galleri/vis/' + this.props.match.params.galleryId);
    }

    handleSelectedFile(event) {
        event.preventDefault();

        if (event.target.files && event.target.files.length > 0) {
            let imageFile = event.target.files[0];
            console.log('handler: ', imageFile);
            let errors = this.validateImageFile(imageFile);
            this.setState({
                // src: imageFile,
                selectedFile: imageFile,
                fileErrorMessages: errors
            });
        }
    };

    validateImageFile(imageFile) {
        let errors = [];

        if (imageFile) {
            if (imageFile.width > this.defaultImageProps.maxWidth) {
                errors.push(`Image width must be less or equal to ${this.defaultImageProps.maxWidth}px`);
            }
            if (imageFile.height > this.defaultImageProps.maxHeight) {
                errors.push(`Image height must be less or equal to ${this.defaultImageProps.maxHeight}px`);
            }
            if (!this.defaultImageProps.mimeType.includes(imageFile.type)) {
                errors.push(`Image mime type must be ${this.defaultImageProps.mimeType}`);
            }
            if (imageFile.size) {
                let sizeMb = imageFile.size / 1024 / 1024;
                if (sizeMb > this.defaultImageProps.maxWeight) {
                    errors.push(`Image size must be less or equal to ${this.defaultImageProps.maxWeight}kb`);
                }
            }
        } else {
            errors.push(plainJSTranslator.formatMessage(messages.required));
        }
        return errors;
    };


    createGalleryImage(formValues) {
        if (!this.state.selectedFile) {
            this.setState({
                fileErrorMessages: [plainJSTranslator.formatMessage(messages.required)]
            });
            return;
        }
        if (this.state.fileErrorMessages.length > 0) {
            return;
        }

        this.setState({isUpdating: true});
        let formData = new FormData();
        formData.append('description', formValues.description);
        formData.append('image', this.state.selectedFile, this.state.selectedFile.name);

        PrivateAPIResource.create(`gallery/add-image/${this.props.match.params.galleryId}`, formData, true)
            .then(galleryImage => {
                toastr.success('Billede uploadet');
                this.redirect();
            })
            .catch(error => {
                console.log(error);
                toastr.error(error);
                // toastr.error('Kunne ikke uploade billedet');
            })
    };

    updateGalleryImage(formValues) {
        if (this.state.selectedFile && this.state.fileErrorMessages.length > 0) {
            return;
        }

        this.setState({isUpdating: true});
        let formData = new FormData();
        formData.append('description', formValues.description);
        if (this.state.selectedFile) {
            formData.append('image', this.state.selectedFile, this.state.selectedFile.name);
        }

        PrivateAPIResource.update(`gallery/update-image/${this.props.match.params.galleryId}`, this.props.match.params.id, formData, true)
            .then(galleryImage => {
                toastr.success('Billede opdateret');
                this.redirect();
            })
            .catch(error => {
                console.log(error);
                toastr.error('Kunne ikke opdater billedet');
                this.redirect();
            })
    };

    submit(formValues) {
        if (this.isUpdate()) {
            this.updateGalleryImage(formValues);
        } else {
            this.createGalleryImage(formValues);
        }
    }

    render() {
        return (
            <WithResolvedPromises preloaderComponent={Placeholder} promises={this.actions} errorComponent={PlaceholderError}>
            <div>
                <div className="row">
                    <div className="col-12">
                        <div className="card m-b-20">
                            <div className="card-block">
                                <div className="row mb-3">
                                    <div className="col-6">
                                        <h1>Billede</h1>
                                    </div>
                                    <div className="col-6 text-right"><Link
                                        to={`/galleri/vis/${this.props.match.params.galleryId}`}
                                        className="btn btn-primary waves-effect list-action"
                                    >
                                        Tilbage til galleriet
                                    </Link>
                                    </div>
                                </div>
                                <GalleryImageForm
                                    initialValues={this.props.galleryImage}
                                    enableReinitialize={true}
                                    keepDirtyOnReinitialize={true}
                                    onSubmit={this.submit}
                                    handleReset={this.handleReset}
                                    isUpdate={this.isUpdate}
                                    isUpdating={this.state.isUpdating}
                                    handleSelectedFile={this.handleSelectedFile}
                                    fileErrorMessages={this.state.fileErrorMessages}
                                    defaultImageProps={this.defaultImageProps}
                                />
                                {
                                    this.isUpdate() &&
                                    <div className="row mt-3">
                                        <div className="col-12">
                                            <img alt="Preview" style={{ maxWidth: "100%" }} src={this.props.galleryImage.filePath} />
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <ResetFormModal
                    modalTitle={this.props.intl.formatMessage(messages.resetModalTitle)}
                    modalContent={
                        <p>
                            <FormattedMessage
                                id="reset.modal.message"
                                defaultMessage="Are you sure, you want to cancel? All of your alterations will be lost."
                            />
                        </p>}
                    confirmText={this.props.intl.formatMessage(messages.buttonYes)}
                    closeText={this.props.intl.formatMessage(messages.buttonNo)}
                    handleConfirm={() => {this.confirmReset()}}
                />
            </div>
            </WithResolvedPromises>
        )
    }
}

GalleryImageFormContainer.contextTypes = {
    router: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
    let errors      = Object.assign({}, getFormSyncErrors('galleryImage')(state));
    let formValues  = Object.assign({}, getFormValues('galleryImage')(state));

    return {
        galleryImage: state.galleryImage,
        errors,
        formValues,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...submitButtonActions,
            ...galleryImageActions,
            ...modalActions,
        }, dispatch)
    }
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(GalleryImageFormContainer));




// WEBPACK FOOTER //
// ./web/src/components/galleries/GalleryImageFormContainer.jsx